<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">الإشعارات التسويقية</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/mNotifications">الإشعارات التسويقية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">تعديل إشعار مجدول</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <MNotificationsForm
              v-if="!mainLoading && row"
              cardTitle="تعديل إشعار مجدول"
              :dataRow="row"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import MNotificationsForm from './form.vue';

export default {
  name: 'MNotificationsUpdate',
  components: {
    MNotificationsForm,
  },
  data() {
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      row: null,
    };
  },
  methods: {
    getRowData() {
      this.$http.get(`/api/admin/mNotifications/retrieve/${this.$route.params.id}`).then(({ data }) => {
        this.row = data.row;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
      });
    },
  },
  created() {
    this.getRowData();
  },
};
</script>